import { defineMessages } from "@/i18n";
import en from "./en";

export const settingsBillingMessages = defineMessages("settings-billing", en);
